import api, { AppFormResult, AppFormSaveData, AppFormQuery } from 'api'
import React, { Fragment } from 'react'
import { AppFormServer, appFormUtils } from './AppFormServer'
import { AppFormContext } from './AppFormContext'
import { AppFormItem, AppFormItemProps } from './AppFormItem'
import { AppFormSectionProps, AppFormSection } from './AppFormSection'
import { AppAction } from 'qcc'

export interface IAppFormApi {
  formDataApi?: (params: { id: string }) => Promise<any>
  saveApi?: (data: any) => Promise<AppFormResult>
}

export interface AppFormProps extends IAppFormApi {
  beforeSave?: (formData: any, appForm?: AppForm) => Promise<boolean>
  afterSave?: (formData: any) => void
  save?: (formData: any) => Promise<AppFormResult>
  formData?: any
  entity?: string  // 实体表名字
  mode?: number        // 1 新增  2 修改  3 查看
  keyName?: string     // 主键ID名称
  keyValue?: string     // 主键的值
  parentId?: string     // 父级ID的值
  keyDataType?: string
  sqlId?: string
  loadingData?: boolean
  exportRef?: (self?: AppForm) => void
}


export class AppForm extends React.Component<AppFormProps>{

  appFormServer = new AppFormServer({ ...this.props, children: this.props.children });
  state = {
    formData: { ...this.props.formData } || {},
    mode: this.props.mode || 1,
    entity: this.props.entity || '',
    keyName: this.props.keyName || 'id',
    keyValue: this.props.keyValue || '0',
    keyDataType: this.props.keyDataType || 'number',
    parentId: this.props.parentId || '0',
    formChange: (this.props.mode || 1) === 1,
    sectionList: this.appFormServer.getSectionList(),
    itemList: this.appFormServer.getItemList()
  }

  static Section = AppFormSection;
  static Item = AppFormItem;

  async componentDidMount() {
    this.props.exportRef && this.props.exportRef(this);
    if (this.props.loadingData) {
      this.initFormData();
    }

  }

  initFormData = async () => {
    let formData = {} as any;
    // 优先级 formDataApi -> sqlId -> 默认取数
    if (this.props.formDataApi) {
      formData = await this.props.formDataApi({ id: this.state.keyValue });
    } else {
      let { entity, keyDataType, keyName, keyValue } = this.state;
      let sqlId = this.props.sqlId || '';
      let formQuery: AppFormQuery = { entity, keyDataType, keyName, keyValue, sqlId, sql: '' };
      formData = await api.public.component.getFormData(formQuery);
    }
    formData = formData || {};
    formData = { ...formData, ...this.state.formData }
    this.setState({ formData });
  }

  beforSave = async () => {
    let { formData } = this.state;
    if (this.props.beforeSave) return await this.props.beforeSave(formData, this);

    if (!this.beReq()) return false;

    return true;
  }

  beReq = () => {
    let { itemList, formData } = this.state
    let reqItemList = itemList.filter(e => e.req) || [];
    let itemCount = reqItemList.length;
    let reqResult = true;
    for (let i = 0; i < itemCount; i++) {
      let item = reqItemList[i];
      let value = formData[item.field] || ''
      if (item.req && value === '') {
        let errorMsg = `请录入${item.label}`
        item = { ...item, errorTips: errorMsg }
        this.setItem(item);
        reqResult = false;
      }
    }

    if (!reqResult) AppAction.warnMsg(`请录入带*号的必填项！`)

    return reqResult;
  }

  getFormData = () => {
    return this.state.formData;
  }

  save = async () => {
    let { formData, formChange } = this.state
    if (!formChange) return false;
    console.log('formData111', formData)
    let res = await this.beforSave();
    if (!res) return false;

    let saveRes: AppFormResult;
    // 优先级 save -> saveApi -> standardSave
    if (this.props.save) {
      saveRes = await this.props.save(formData);
    } else if (this.props.saveApi) {
      saveRes = await this.props.saveApi(formData);
    } else {
      saveRes = await this.handleStandardSave();
    }

    if (saveRes.result) {
      AppAction.successMsg('保存成功！')
      this.afterSave();
    } else {
      AppAction.errorMsg(saveRes.msg);
      return true;
    }

    return true;
  }

  handleStandardSave = async () => {
    let { entity, keyName, keyValue, parentId, keyDataType, mode, formData } = this.state;
    let itemList = appFormUtils.getSaveDataItemList(formData, this.state.itemList);
    let formSaveData: AppFormSaveData = { entity, keyName, keyValue, parentId, keyDataType, mode, itemList };
    let formSaveResult = await api.public.component.saveForm(formSaveData);
    return formSaveResult;
  }

  afterSave = async () => {
    let { formData } = this.state
    this.props.afterSave && this.props.afterSave(formData);
  }


  getItem = (field: string) => {
    return this.state.itemList.find(o => o.field === field)!;
  }

  setItem = (appFormItem: AppFormItemProps) => {
    let itemList = this.state.itemList.map((item: AppFormItemProps) => {
      return item.field === appFormItem.field ? { ...appFormItem } : { ...item };
    })
    this.setState({ itemList });
  }

  onValueChange = (formData?: any) => {

    this.setState({ formData: { ...formData }, formChange: true });
  }

  onItemValueChange = (field?: string, value?: any) => {
    let { formData } = this.state;
    let newFormData = { ...formData, [field]: value }
    console.log('formDataqq', newFormData)
    this.setState({ formData: JSON.parse(JSON.stringify(newFormData)), formChange: true });
  }

  onItemChange = (appFormItem: AppFormItemProps) => {
    let { keyName, textKeyName } = appFormItem;
    if (keyName === '') return;

    let formData = { ...this.state.formData, [keyName]: appFormUtils.getItemValue(appFormItem) };
    if (textKeyName !== '') {
      formData = { ...formData, [textKeyName]: (appFormItem.text || '') }
    }

    this.setState({ formData, formChange: true })
    appFormItem.onFormItemChange && appFormItem.onFormItemChange(formData);


  }

  renderSection = () => {
    let { sectionList, itemList } = this.state;
    return (<div className='app-form-container'>
      {sectionList.map((section: AppFormSectionProps) => {
        let { sectionKey } = section;
        let items = itemList.filter(e => e.sectionKey === sectionKey && !e.hidden && e.itemType !== 'hidden');
        let sectionProps = { ...section, items }
        return <AppFormSection key={section.sectionKey}  {...sectionProps} />
      })}
    </div>)
  }

  render() {
    let { mode, formData } = this.state;
    return (
      <AppFormContext.Provider value={{
        formData,
        mode,
        onChange: this.onItemChange
      }}>
        {this.renderSection()}
      </AppFormContext.Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/qcc/AppForm/AppForm.tsx